import { render, staticRenderFns } from "./RoleModule.vue?vue&type=template&id=343eb02b&scoped=true"
import script from "./RoleModule.vue?vue&type=script&lang=js"
export * from "./RoleModule.vue?vue&type=script&lang=js"
import style0 from "./RoleModule.vue?vue&type=style&index=0&id=343eb02b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343eb02b",
  null
  
)

export default component.exports